import api from "../utils/api"; 

class RateApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/rates', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/rates', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise((resolve, reject) => {
      return api
        .patch(`/rates/${id}`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  delete = (id) => {
    return new Promise((resolve, reject) => {
      return api
        .delete(`/rates/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/rates/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  clear = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete('/rates', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const rateApi = new RateApi();
export default rateApi;
